import { render, staticRenderFns } from "./AcademicasIndicadoresComponent.vue?vue&type=template&id=e1caf15c&scoped=true&"
import script from "./AcademicasIndicadoresComponent.vue?vue&type=script&lang=js&"
export * from "./AcademicasIndicadoresComponent.vue?vue&type=script&lang=js&"
import style0 from "./AcademicasIndicadoresComponent.vue?vue&type=style&index=0&id=e1caf15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1caf15c",
  null
  
)

export default component.exports